import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { BaryModalEvent } from '../../../../../../models/bary-modal-event';
import { patchObject } from '../../../../util/object-util';
import { InsuranceItem, InsuranceItemControls } from '../../../../../../models/insurance-item.model';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';
import { BaryInputTextComponent } from '../../../bary-input-text/bary-input-text.component';
import { BaryInputNumberComponent } from '../../../bary-input-number/bary-input-number.component';
import { BaryButtonComponent } from '../../../bary-button/bary-button.component';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jhi-modal-add-or-update-insurance-item',
  templateUrl: './modal-add-or-update-insurance-item.component.html',
  styleUrls: ['./modal-add-or-update-insurance-item.component.scss'],
  standalone: true,
  imports: [BaryInputTextComponent, BaryInputNumberComponent, BaryButtonComponent, TranslateDirective, NgIf, TranslateModule],
})
export class ModalAddOrUpdateInsuranceItemComponent extends BaryModalForm implements OnInit {
  readonly #modalRef = inject(MDBModalRef);
  readonly #bfc = inject(BaryFormFactoryService);
  readonly #fb = inject(FormBuilder);

  override model: InsuranceItem = new InsuranceItem();

  public type: 'create' | 'update' = 'create';
  public itemsNatureList: string[] = [];

  public controls?: InsuranceItemControls;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.controls = this.#bfc.makeInsuranceItemControls(this.model, this.itemsNatureList);
    this.modalForm = this.#fb.group(this.controls);
  }

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      patchObject(this.model, this.modalForm.value);
      this.model.itemsNature = this.model.itemsNature.trim();
      this.action.next(new BaryModalEvent({ submit: true, value: this.model.serialize() }));
      this.#modalRef.hide();
    }
  }
}
